var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body_monban"},[_c('el-tabs',{staticStyle:{"height":"200px"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"活动","name":"huodong"}},[_c('tuwen',{attrs:{"tuwen_type":21,"show_type":1,"update_flag":1}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }